// ** MUI Imports
import { styled, useTheme } from '@mui/material/styles'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import MuiAppBar from '@mui/material/AppBar'
import MuiToolbar from '@mui/material/Toolbar'

// ** Util Import
import { hexToRGBA } from 'src/@core/utils/hex-to-rgba'

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  transition: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 5),
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  minHeight: 56,
  [theme.breakpoints.down('md')]: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}))

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadius,
  padding: `${theme.spacing(0, 2)} !important`,
  minHeight: `56px !important`,
  transition: 'padding .25s ease-in-out, box-shadow .25s ease-in-out, border-color .25s ease-in-out'
}))

const LayoutAppBar = props => {
  const { settings, verticalAppBarContent: userVerticalAppBarContent } = props

  const theme = useTheme()
  const scrollTrigger = useScrollTrigger({ threshold: 0, disableHysteresis: true })

  const { skin, appBar, appBarBlur, contentWidth } = settings

  const appBarFixedStyles = () => {
    return {
      px: `${theme.spacing(2)} !important`,
      ...(appBarBlur && { backdropFilter: 'blur(10px)' }),
      boxShadow: '0 1px 2px rgba(26, 35, 50, 0.06)',
      backgroundColor: hexToRGBA(theme.palette.background.paper, appBarBlur ? 0.92 : 1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      ...(skin === 'bordered' && { border: `1px solid ${theme.palette.divider}`, borderTopWidth: 0 })
    }
  }
  if (appBar === 'hidden') {
    return null
  }

  return (
    <AppBar elevation={0} color='default' className='layout-navbar' position={appBar === 'fixed' ? 'sticky' : 'static'}>
      <Toolbar
        className='navbar-content-container'
        sx={{
          ...(appBar === 'fixed' && scrollTrigger && { ...appBarFixedStyles() }),
          ...(appBar === 'fixed' && !scrollTrigger && {
            backgroundColor: theme.palette.background.paper,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }),
          ...(contentWidth === 'boxed' && {
            '@media (min-width:1440px)': { maxWidth: `calc(1440px - ${theme.spacing(6)} * 2)` }
          })
        }}
      >
        {(userVerticalAppBarContent && userVerticalAppBarContent(props)) || null}
      </Toolbar>
    </AppBar>
  )
}

export default LayoutAppBar
